<template>
    <div class="LoadingCont">
        <img src="@/assets/img/loading.gif" alt="" class="loadingIcon" />
    </div>
</template>
<script setup>

</script>
<style lang="scss" scoped>
.LoadingCont {
    height: 30px;
    width: 70px;

    .loadingIcon {
        width: 70px;
        width: 70px;
        position: absolute;
        top: -15px;
        left: 0;
        z-index: -1;
    }
}
</style>